import areIntlLocalesSupported from "intl-locales-supported";

const IntlPolyfill = require("intl");
require("intl/locale-data/jsonp/es");
require("intl/locale-data/jsonp/es-CL");


const customDateTimeFormat = {
  cl: () => {
    if (areIntlLocalesSupported(["es", "es-CL"])) {
      return global.Intl.DateTimeFormat;
    }
    return IntlPolyfill.DateTimeFormat;
  },
};

export default customDateTimeFormat;
